import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BookingSubscriptionPackageOptions, RemoteConfigStore } from '@store';

@Component({
  selector: 'app-subscription-summary-wrapper',
  templateUrl: './subscription-summary-wrapper.component.html',
  styleUrls: ['./subscription-summary-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionSummaryWrapperComponent {
  BookingSubscriptionPackageOptions = BookingSubscriptionPackageOptions;

  constructor(public remoteConfigStore: RemoteConfigStore) {}
}
